import React, { useEffect, useState } from 'react';
import { Star, Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Videos',
    href: '#videos'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }, {
    name: 'Tour Dates',
    href: '#tour'
  }];
  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-tx-primary/95 backdrop-blur-sm border-b border-tx-border py-3 shadow-lg' : 'bg-transparent py-5'}`} data-id="element-146">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <div className="flex items-center justify-between" data-id="element-148">
          {/* Logo */}
          <a href="#hero" className="flex items-center gap-2 group" onClick={handleNavClick} data-id="element-149">
            <Star className="w-6 h-6 text-tx-cream group-hover:text-tx-red transition-colors duration-300 fill-current" data-id="element-150" />
            <span className="font-heading text-3xl tracking-widest text-tx-cream group-hover:text-tx-red transition-colors duration-300" data-id="element-151">
              TEXARKANA
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-152">
            {navLinks.map(link => <a key={link.name} href={link.href} className="font-heading text-xl text-tx-cream/80 hover:text-tx-cream relative group tracking-wider" data-id="element-153">
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-tx-red transition-all duration-300 group-hover:w-full" data-id="element-154"></span>
              </a>)}
            <a href="#booking" className="font-heading text-xl px-5 py-2 border-2 border-tx-red text-tx-red hover:bg-tx-red hover:text-tx-cream transition-all duration-300 tracking-wider" data-id="element-155">
              BOOK US
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-tx-cream hover:text-tx-red transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-156">
            {isMobileMenuOpen ? <X className="w-8 h-8" data-id="element-157" /> : <Menu className="w-8 h-8" data-id="element-158" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <div className={`md:hidden absolute top-full left-0 w-full bg-tx-primary border-b border-tx-border transition-all duration-300 overflow-hidden ${isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-159">
        <nav className="flex flex-col px-4 py-6 gap-4" data-id="element-160">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={handleNavClick} className="font-heading text-2xl text-tx-cream hover:text-tx-red transition-colors tracking-wider block py-2 border-b border-tx-border/50" data-id="element-161">
              {link.name}
            </a>)}
          <a href="#booking" onClick={handleNavClick} className="font-heading text-2xl text-tx-red hover:text-tx-cream transition-colors tracking-wider block py-2 mt-2" data-id="element-162">
            BOOK US
          </a>
        </nav>
      </div>
    </header>;
}